<template>
  <!-- 患者対応登録/編集 -->
  <div id="AppUrgentEdit">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div class="columns" style="margin-left: 100px; margin-Right: 100px;">
      <div class="column is-full">
        <label class="searchTitle label">
          患者対応
          <span v-if="status=='0'">登録</span>
          <span v-else-if="status=='3'||status=='4'">参照</span>
          <span v-else>編集</span>
        </label>
      </div>
    </div>
    <div class="columns" style="margin-left: 100px; margin-Right: 100px;">
      <div class="column is-full">
        <div class="box">
          <div class="columns">
            <div class="column is-full subTitle">
              <span>対応状況：</span>
              <span
                :class="['tag',
                  {'is-info':status ==  0},
                  {'is-danger':status == 1},
                  {'is-warning':status == 2},
                  {'is-success':status == 3},
                  {'is-dark':status == 4},
                  {'is-info':status ==  5},
                  ]"
              >{{status|urgentStatusFillter}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns" style="margin-left: 100px; margin-Right: 100px;">
      <div class="column is-full">
        <div class="box">
          <div class="columns">
            <div class="column is-full">
              <label class="searchTitle label">受電対応</label>
            </div>
          </div>
          <div class="columns">
            <div class="column is-full subTitle">
              <span>受信者情報</span>
            </div>
          </div>
          <div class="columns">
            <div class="column is-one-quarter">
              <b-field label="受信者" labelPosition="on-border">
                <b-input v-model="data.inquiry.staffName" :readonly="true"></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field label="支店" labelPosition="on-border">
                <b-input
                  :value="inquiryResponsibleOfficeFilter(data.inquiry.officeCode)"
                  :readonly="true"
                ></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-one-quarter">
              <b-field
                label="受信日"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('date')}"
                :message="errors.first('date')"
              >
                <b-datepicker
                  v-if="canInquiryEdit"
                  v-model="date"
                  name="date"
                  type="day"
                  placeholder="受信日"
                  data-vv-as="受信日"
                  v-validate="'required'"
                  icon="calendar-today"
                  :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                  :day-names="['日','月','火','水','木','金','土']"
                ></b-datepicker>
                <b-input v-else v-model="data.inquiry.date" readonly="true"></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field
                label="開始時間"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('startTime')}"
                :message="errors.first('startTime')"
              >
                <b-timepicker
                  v-if="canInquiryEdit"
                  v-model="startTime"
                  placeholder="Type or select a date..."
                  name="startTime"
                  data-vv-as="開始時間"
                  v-validate="'required'"
                  icon="clock"
                ></b-timepicker>
                <b-input v-else v-model="data.inquiry.startTime" readonly="true"></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field
                label="終了時間"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('endTime')}"
                :message="errors.first('endTime')"
              >
                <b-timepicker
                  v-if="canInquiryEdit"
                  v-model="endTime"
                  placeholder="Type or select a date..."
                  name="endTime"
                  data-vv-as="終了時間"
                  v-validate="'required|endTimeCheck'"
                  icon="clock"
                ></b-timepicker>
                <b-input v-else v-model="data.inquiry.endTime" :readonly="true"></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-full subTitle">
              <span>送信元情報</span>
            </div>
          </div>
          <div class="columns">
            <div class="column is-one-quarter">
              <b-field
                label="種類"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('kind')}"
                :message="errors.first('kind')"
              >
                <b-select
                  expanded
                  v-model="data.inquiry.kind"
                  v-if="canInquiryEdit"
                  name="kind"
                  data-vv-as="種類"
                  v-validate="'required|selectRange:0:6'"
                >
                  <option value="0">呼吸</option>
                  <option value="1">睡眠</option>
                  <option value="2">当番変更</option>
                  <option value="3">呼吸ケア用品</option>
                  <option value="4">間違い</option>
                  <option value="5">ワンギリ</option>
                  <option value="6">その他</option>
                </b-select>
                <b-input v-else :value="inquiryKindFilter(data.inquiry.kind)" :readonly="true"></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field
                label="送信者名"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('senderName')}"
                :message="errors.first('senderName')"
              >
                <b-input
                  v-model="data.inquiry.senderName"
                  :readonly="!canInquiryEdit"
                  name="senderName"
                  data-vv-as="送信者名"
                  v-validate="'required|max:50'"
                  maxlength="50"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field
                label="着信電話番号"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('incomingPhoneNumber')}"
                :message="errors.first('incomingPhoneNumber')"
              >
                <b-input
                  v-model="data.inquiry.incomingPhoneNumber"
                  :readonly="!canInquiryEdit"
                  name="incomingPhoneNumber"
                  v-validate="'required|max:20'"
                  data-vv-as="着信電話番号"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field
                label="連絡先電話番号"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('contactPhoneNumber')}"
                :message="errors.first('contactPhoneNumber')"
              >
                <b-input
                  v-model="data.inquiry.contactPhoneNumber"
                  :readonly="!canInquiryEdit"
                  name="contactPhoneNumber"
                  data-vv-as="連絡先電話番号"
                  v-validate="'required|max:20'"
                ></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half">
              <b-field
                label="患者名"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('pacientName')}"
                :message="errors.first('pacientName')"
              >
                <b-input
                  v-model="data.inquiry.pacientName"
                  :readonly="true"
                  name="pacientName"
                  data-vv-as="患者名"
                  v-validate="'required'"
                  expanded
                ></b-input>
                <b-button
                  v-if="status!=3"
                  :disabled="!canInquiryEdit"
                  style="float:right"
                  class="button is-primary has-text-centered"
                  icon-left="account-switch"
                  native-type="button"
                  v-on:click="changePatient"
                >患者選択</b-button>
              </b-field>
              <b-modal :active.sync="isSelectPatientActive" full-screen>
                <selectPatient-form v-on:set-patient="setPatientName"></selectPatient-form>
              </b-modal>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half">
              <b-field
                label="医療機関"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('hospitalName')}"
                :message="errors.first('hospitalName')"
              >
                <b-input
                  v-model="data.inquiry.hospitalName"
                  :readonly="!canInquiryEdit"
                  name="hospitalName"
                  data-vv-as="医療機関名"
                  v-validate="'max:150'"
                  maxlength="150"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field
                label="病棟"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('hospitalWard')}"
                :message="errors.first('hospitalWard')"
              >
                <b-input
                  v-model="data.inquiry.hospitalWard"
                  :readonly="!canInquiryEdit"
                  name="hospitalWard"
                  data-vv-as="病棟名"
                  v-validate="'max:35'"
                  maxlength="35"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field
                label="～科"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('hospitalSection')}"
                :message="errors.first('hospitalSection')"
              >
                <b-input
                  v-model="data.inquiry.hospitalSection"
                  :readonly="!canInquiryEdit"
                  name="hospitalSection"
                  data-vv-as="診療科名"
                  v-validate="'max:35'"
                  maxlength="35"
                ></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-full subTitle">
              <span>機器情報</span>
            </div>
          </div>
          <div class="columns">
            <div class="column is-one-quarter">
              <b-field
                label="項目"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('deviceLocation')}"
                :message="errors.first('deviceLocation')"
              >
                <b-select
                  v-model="data.inquiry.deviceLocation"
                  expanded
                  v-if="canInquiryEdit"
                  name="deviceLocation"
                  data-vv-as="項目"
                  v-validate="'required|selectRange:0:4'"
                >
                  <option value="0">院内</option>
                  <option value="1">在宅</option>
                  <option value="2">施設</option>
                  <option value="3">業者</option>
                  <option value="4">その他</option>
                </b-select>
                <b-input
                  v-else
                  :value="inquiryDevLocationFilter(data.inquiry.deviceLocation)"
                  :readonly="true"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-half">
              <b-field
                label="受信区分"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('requestType')}"
                :message="errors.first('requestType')"
              >
                <b-select
                  v-model="data.inquiry.requestType"
                  expanded
                  v-if="canInquiryEdit"
                  name="requestType"
                  data-vv-as="受信区分"
                  v-validate="'required|selectRange:0:11'"
                >
                  <option value="0">問合せ</option>
                  <option value="1">連絡</option>
                  <option value="2">用品注文</option>
                  <option value="3">レンタル依頼</option>
                  <option value="4">引上げ依頼</option>
                  <option value="5">不具合（電源・バッテリー）</option>
                  <option value="6">不具合（回路等が原因と思われる）</option>
                  <option value="7">設定・使用方法の問題と思われる</option>
                  <option value="8">不具合（器械原因と思われる）</option>
                  <option value="9">作動停止</option>
                  <option value="10">詳細不明</option>
                  <option value="11">除外</option>
                </b-select>
                <b-input
                  v-else
                  :value="inquiryRequestTypeFilter(data.inquiry.requestType)"
                  :readonly="true"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field
                label="支店"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('responsibleOfficeCode')}"
                :message="errors.first('responsibleOfficeCode')"
              >
                <b-select
                  expanded
                  v-if="canInquiryEdit"
                  v-model="data.inquiry.responsibleOfficeCode"
                  name="responsibleOfficeCode"
                  data-vv-as="支店"
                  v-validate="'required'"
                >
                  <option
                    v-for="office in officeMaster"
                    :value="office.officeCode"
                    :key="office.officeCode"
                  >{{ office.officeName }}</option>
                </b-select>
                <b-input
                  v-else
                  :value="inquiryResponsibleOfficeFilter(data.inquiry.responsibleOfficeCode)"
                  :readonly="true"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter"></div>
          </div>
          <div class="columns">
            <div class="column is-helf">
              <b-field
                label="該当機器/商品"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('deviceName')}"
                :message="errors.first('deviceName')"
              >
                <b-input
                  v-model="data.inquiry.deviceName"
                  :readonly="!canInquiryEdit"
                  name="deviceName"
                  data-vv-as="該当機器/商品"
                  v-validate="'required|max:100'"
                  maxlength="100"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-helf">
              <b-field
                label="併用機器"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('combinedDeviceName')}"
                :message="errors.first('combinedDeviceName')"
              >
                <b-input
                  v-model="data.inquiry.combinedDeviceName"
                  :readonly="!canInquiryEdit"
                  name="combinedDeviceName"
                  data-vv-as="併用機器"
                  v-validate="'required|max:100'"
                  maxlength="100"
                ></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-one-quarter">
              <b-field
                label="呼吸回路"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('breathingCircuite')}"
                :message="errors.first('breathingCircuite')"
              >
                <b-select
                  v-model="data.inquiry.breathingCircuite"
                  expanded
                  v-if="canInquiryEdit"
                  name="breathingCircuite"
                  data-vv-as="呼吸回路"
                  v-validate="'required|selectRange:0:6'"
                >
                  <option value="0">リューザブル</option>
                  <option value="1">ディスポ</option>
                  <option value="2">ﾊﾟｯｼﾌﾞ</option>
                  <option value="3">ｱｸﾃｨﾌﾞ</option>
                  <option value="4">ｱｸﾃｨﾌﾞﾌﾛｰ</option>
                  <option value="5">N/A</option>
                  <option value="6">不明</option>
                </b-select>
                <b-input
                  v-else
                  :value="inquiryBreathingCircuiteFilter(data.inquiry.breathingCircuite)"
                  :readonly="true"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field
                label="装着"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('wearingStatus')}"
                :message="errors.first('wearingStatus')"
              >
                <b-select
                  v-model="data.inquiry.wearingStatus"
                  expanded
                  v-if="canInquiryEdit"
                  name="wearingStatus"
                  data-vv-as="装着"
                  v-validate="'required|selectRange:0:8'"
                >
                  <option value="0">挿管</option>
                  <option value="1">気管切開</option>
                  <option value="2">鼻ｶﾆｭｰﾗ</option>
                  <option value="3">ﾏｽｸ</option>
                  <option value="4">鼻ﾏｽｸ</option>
                  <option value="5">鼻口ﾏｽｸ</option>
                  <option value="6">ﾄｰﾀﾙﾌｪｲｽﾏｽｸ</option>
                  <option value="7">N/A</option>
                  <option value="8">不明</option>
                </b-select>
                <b-input
                  v-else
                  :value="inquiryWearingStatusFilter(data.inquiry.wearingStatus)"
                  :readonly="true"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field
                label="加湿"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('humidifier')}"
                :message="errors.first('humidifier')"
              >
                <b-select
                  v-model="data.inquiry.humidifier"
                  expanded
                  v-if="canInquiryEdit"
                  name="humidifier"
                  data-vv-as="加湿"
                  v-validate="'required|selectRange:0:3'"
                >
                  <option value="0">加湿器</option>
                  <option value="1">人工鼻</option>
                  <option value="2">N/A</option>
                  <option value="3">不明</option>
                </b-select>
                <b-input
                  v-else
                  :value="inquiryHumidifierFilter(data.inquiry.humidifier)"
                  :readonly="true"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter"></div>
          </div>
          <div class="columns">
            <div class="column is-one-quarter">
              <b-field
                label="事象発生時にアラームは鳴ったか？"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('alarmOccurrence')}"
                :message="errors.first('alarmOccurrence')"
              >
                <b-select
                  v-model="data.inquiry.alarmOccurrence"
                  expanded
                  v-if="canInquiryEdit"
                  name="alarmOccurrence"
                  data-vv-as="発生時アラーム"
                  v-validate="'required|selectRange:0:3'"
                >
                  <option value="0">いいえ</option>
                  <option value="1">はい</option>
                  <option value="2">N/A</option>
                  <option value="3">不明</option>
                </b-select>
                <b-input
                  v-else
                  :value="situationFilter(data.inquiry.alarmOccurrence)"
                  :readonly="true"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field
                label="事象発生時にその器械を使用していたか？"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('usedDevice')}"
                :message="errors.first('usedDevice')"
              >
                <b-select
                  v-model="data.inquiry.usedDevice"
                  expanded
                  v-if="canInquiryEdit"
                  name="usedDevice"
                  data-vv-as="発生時器械使用"
                  v-validate="'required|selectRange:0:3'"
                >
                  <option value="0">いいえ</option>
                  <option value="1">はい</option>
                  <option value="2">N/A</option>
                  <option value="3">不明</option>
                </b-select>
                <b-input v-else :value="situationFilter(data.inquiry.usedDevice)" :readonly="true"></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field
                label="体調に変化はあったか？"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('physicalCondition')}"
                :message="errors.first('physicalCondition')"
              >
                <b-select
                  v-model="data.inquiry.physicalCondition"
                  expanded
                  v-if="canInquiryEdit"
                  name="physicalCondition"
                  data-vv-as="体調変化"
                  v-validate="'required|selectRange:0:3'"
                >
                  <option value="0">いいえ</option>
                  <option value="1">はい</option>
                  <option value="2">N/A</option>
                  <option value="3">不明</option>
                </b-select>
                <b-input
                  v-else
                  :value="situationFilter(data.inquiry.physicalCondition)"
                  :readonly="true"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field
                label="新品を開封した時点で発見した不具合か？"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('newDevice')}"
                :message="errors.first('newDevice')"
              >
                <b-select
                  v-model="data.inquiry.newDevice"
                  expanded
                  v-if="canInquiryEdit"
                  name="newDevice"
                  data-vv-as="新品開封"
                  v-validate="'required|selectRange:0:3'"
                >
                  <option value="0">いいえ</option>
                  <option value="1">はい</option>
                  <option value="2">N/A</option>
                  <option value="3">不明</option>
                </b-select>
                <b-input v-else :value="situationFilter(data.inquiry.newDevice)" :readonly="true"></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-full subTitle">
              <label class="searchTitle label">受信内容</label>
            </div>
          </div>
          <div class="columns">
            <div class="column is-full subTitle">
              <span>受信内容</span>
            </div>
          </div>
          <div class="columns">
            <div class="column is-full">
              <b-field
                :type="{'is-danger':errors.has('inquiryContent')}"
                :message="errors.first('inquiryContent')"
              >
                <b-input
                  type="textarea"
                  v-model="data.inquiry.inquiryContent"
                  :readonly="!canInquiryEdit"
                  name="inquiryContent"
                  data-vv-as="受信内容"
                  v-validate="'required|max:512'"
                  maxlength="512"
                ></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-full subTitle">
              <span>対応内容</span>
            </div>
          </div>
          <div class="columns">
            <div class="column is-full">
              <b-field
                label="対応内容記号"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('supportType')}"
                :message="errors.first('supportType')"
              >
                <b-select
                  v-model="data.inquiry.supportType"
                  expanded
                  v-if="canInquiryEdit"
                  name="supportType"
                  data-vv-as="対応内容記号"
                  v-validate="'required|selectRange:0:3'"
                >
                  <option value="0">1：電話番号案内</option>
                  <option value="1">2：入電で一時解決</option>
                  <option value="2">3：待機当番へ対応依頼（支店担当含む）</option>
                  <option value="3">4：その他（1～3以外）</option>
                </b-select>
                <b-input
                  v-else
                  :value="inquirySupportTypeFilter(data.inquiry.supportType)"
                  :readonly="true"
                ></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-full">
              <b-field
                label="対応内容"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('supportContent')}"
                :message="errors.first('supportContent')"
              >
                <b-input
                  type="textarea"
                  v-model="data.inquiry.supportContent"
                  :readonly="!canInquiryEdit"
                  name="supportContent"
                  data-vv-as="その他の詳細な区分"
                  v-validate="'max:512'"
                  maxlength="512"
                ></b-input>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="columns"
      style="margin-left: 100px; margin-Right: 100px;"
      v-if="status !=0 && status !=5"
    >
      <div class="column is-full">
        <div class="box">
          <div class="columns">
            <div class="column is-full">
              <label class="searchTitle label">支店対応</label>
            </div>
          </div>
          <div class="columns">
            <div class="column is-one-third">
              <b-field label="支店" labelPosition="on-border">
                <b-input
                  :value="inquiryResponsibleOfficeFilter(data.support.officeCode)"
                  :readonly="true"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-one-third">
              <b-field
                label="支店対応者"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('staffName')}"
                :message="errors.first('staffName')"
              >
                <b-input
                  v-model="data.support.staffName"
                  :readonly="true"
                  name="staffName"
                  data-vv-as="支店対応者"
                  v-validate="'required'"
                ></b-input>
                <template v-if="canSupportOfficeEdit">
                  <b-button
                    style="float:right; bottom:0;"
                    class="button is-primary has-text-centered"
                    icon-left="account-switch"
                    native-type="button"
                    v-on:click="changeStaff"
                  ></b-button>
                  <b-modal :active.sync="isSupportStaffChangeActive" has-modal-card>
                    <staffChange-modal
                      v-bind:office-code="officeCode"
                      v-on:staff-change-event="staffChanged"
                    ></staffChange-modal>
                  </b-modal>
                </template>
              </b-field>
            </div>
            <div class="column is-one-third">
              <b-field
                label="対応日"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('periodstart')}"
                :message="errors.first('periodstart')"
              >
                <b-datepicker
                  v-if="canSupportOfficeEdit"
                  v-model="supportDate"
                  name="periodstart"
                  type="day"
                  placeholder="対応日"
                  data-vv-as="対応日"
                  v-validate="'required'"
                  icon="calendar-today"
                  :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                  :day-names="['日','月','火','水','木','金','土']"
                ></b-datepicker>
                <b-input v-else v-model="data.support.date" readonly="true"></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-full subTitle">
              <span>対応区分</span>
            </div>
          </div>
          <div class="columns">
            <div class="column is-full">
              <b-field
                grouped
                group-multiline
                :type="{'is-danger':errors.has('support.kind')}"
                :message="errors.first('support.kind')"
              >
                <b-checkbox
                  v-if="canSupportOfficeEdit"
                  v-model="data.support.kind.operationStop"
                  name="support.kind"
                  v-validate="'supportKind'"
                >作動停止</b-checkbox>
                <b-checkbox v-else v-model="data.support.kind.operationStop" disabled>作動停止</b-checkbox>

                <b-checkbox
                  v-if="canSupportOfficeEdit"
                  v-model="data.support.kind.malfunction"
                  name="support.kind"
                  v-validate="'supportKind'"
                >不具合（機械故障）</b-checkbox>
                <b-checkbox v-else v-model="data.support.kind.malfunction" disabled>不具合（機械故障）</b-checkbox>

                <b-checkbox
                  v-if="canSupportOfficeEdit"
                  v-model="data.support.kind.malfunctionPower"
                  name="support.kind"
                  v-validate="'supportKind'"
                >不具合（電源・ﾊﾞｯﾃﾘｰ）</b-checkbox>
                <b-checkbox
                  v-else
                  v-model="data.support.kind.malfunctionPower"
                  disabled
                >不具合（電源・ﾊﾞｯﾃﾘｰ）</b-checkbox>

                <b-checkbox
                  v-if="canSupportOfficeEdit"
                  v-model="data.support.kind.defective"
                  name="support.kind"
                  v-validate="'supportKind'"
                >回路・ﾏｽｸ・ｶｰﾄﾞ不良</b-checkbox>
                <b-checkbox v-else v-model="data.support.kind.defective" disabled>回路・ﾏｽｸ・ｶｰﾄﾞ不良</b-checkbox>

                <b-checkbox
                  v-if="canSupportOfficeEdit"
                  v-model="data.support.kind.configuration"
                  name="support.kind"
                  v-validate="'supportKind'"
                >設定･使用方法の問題</b-checkbox>
                <b-checkbox v-else v-model="data.support.kind.configuration" disabled>設定･使用方法の問題</b-checkbox>

                <b-checkbox
                  v-if="canSupportOfficeEdit"
                  v-model="data.support.kind.other"
                  name="support.kind"
                  v-validate="'supportKind'"
                >その他</b-checkbox>
                <b-checkbox v-else v-model="data.support.kind.other" disabled>その他</b-checkbox>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-full">
              <b-field
                :type="{'is-danger':errors.has('otherDetail')}"
                :message="errors.first('otherDetail')"
              >
                <b-input
                  v-if="data.support.kind.other"
                  placeholder="その他の場合、記入してください。"
                  v-model="data.support.kind.otherDetail"
                  :readonly="!canSupportOfficeEdit"
                  name="otherDetail"
                  data-vv-as="その他の詳細な区分"
                  v-validate="`${data.support.kind.other ? 'required|' : ''}max:100`"
                  maxlength="100"
                ></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-full subTitle">
              <span>状況</span>
            </div>
          </div>
          <div class="columns">
            <div class="column is-one-quarter">
              <b-field
                label="患者に健康被害はあったか？"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('healthDamage')}"
                :message="errors.first('healthDamage')"
              >
                <b-select
                  v-model="data.support.healthDamage"
                  expanded
                  v-if="canSupportOfficeEdit"
                  name="healthDamage"
                  data-vv-as="健康被害"
                  v-validate="'required|selectRange:0:1'"
                >
                  <option value="0">いいえ</option>
                  <option value="1">はい</option>
                </b-select>
                <b-input
                  v-else
                  :value="situationFilter(data.support.healthDamage)"
                  :readonly="true"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field
                label="新品を開封した時点で発見した不具合か？"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('support.newDevice')}"
                :message="errors.first('support.newDevice')"
              >
                <b-select
                  v-model="data.support.newDevice"
                  expanded
                  v-if="canSupportOfficeEdit"
                  name="support.newDevice"
                  data-vv-as="新品開封"
                  v-validate="'required|selectRange:0:3'"
                >
                  <option value="0">いいえ</option>
                  <option value="1">はい</option>
                  <option value="2">N/A</option>
                  <option value="3">不明</option>
                </b-select>
                <b-input v-else :value="situationFilter(data.support.newDevice)" :readonly="true"></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field
                label="機械交換実施"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('replacement')}"
                :message="errors.first('replacement')"
              >
                <b-select
                  v-model="data.support.replacement"
                  expanded
                  v-if="canSupportOfficeEdit"
                  name="replacement"
                  data-vv-as="機械交換実施"
                  v-validate="'required|selectRange:0:1'"
                >
                  <option value="0">あり</option>
                  <option value="1">なし</option>
                </b-select>
                <b-input
                  v-else
                  :value="supportOfficeReplacementFilter(data.support.replacement)"
                  :readonly="true"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field
                label="事象発生の確認"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('location')}"
                :message="errors.first('location')"
              >
                <b-select
                  v-model="data.support.location"
                  expanded
                  v-if="canSupportOfficeEdit"
                  name="location"
                  data-vv-as="事象発生の確認"
                  v-validate="'required|selectRange:0:2'"
                >
                  <option value="0">現場</option>
                  <option value="1">支店</option>
                  <option value="2">確認不可</option>
                </b-select>
                <b-input
                  v-else
                  :value="supportOfficeLocationFilter(data.support.location)"
                  :readonly="true"
                ></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-full subTitle">
              <span>対処内容</span>
            </div>
          </div>
          <div class="columns">
            <div class="column is-full">
              <b-field
                label="対処内容"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('dealType')}"
                :message="errors.first('dealType')"
              >
                <b-select
                  v-model="data.support.dealType"
                  expanded
                  v-if="canSupportOfficeEdit"
                  name="dealType"
                  data-vv-as="対処内容"
                  v-validate="'required|selectRange:0:2'"
                >
                  <option value="0">電話/商品発送にて対応</option>
                  <option value="1">営業時間内出動にて対応</option>
                  <option value="2">営業時間外出動にて対応</option>
                </b-select>
                <b-input
                  v-else
                  :value="supportOfficedealTypeFilter(data.support.dealType)"
                  :readonly="true"
                ></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-full">
              <b-field
                :type="{'is-danger':errors.has('dealDetailes')}"
                :message="errors.first('dealDetailes')"
              >
                <b-input
                  v-if="canSupportOfficeEdit"
                  type="textarea"
                  placeholder="対処内容を記載してください。"
                  v-model="data.support.dealDetails"
                  :readonly="!canSupportOfficeEdit"
                  name="dealDetailes"
                  data-vv-as="対処内容"
                  v-validate="'required|max:512'"
                  maxlength="512"
                ></b-input>
                <b-input
                  v-else
                  type="textarea"
                  v-model="data.support.dealDetails"
                  :readonly="!canSupportOfficeEdit"
                ></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-full subTitle">
              <span>※機器安全センター評価</span>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half">
              <b-field
                label="①営業担当者への連絡は適切でしたか？"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('assessment1')}"
                :message="errors.first('assessment1')"
              >
                <b-select
                  v-model="data.support.assessment1"
                  expanded
                  v-if="canSupportOfficeEdit"
                  name="assessment1"
                  data-vv-as="機器安全センター評価①"
                  v-validate="'selectRange:0:5'"
                >
                  <option value="1">1 不満 （不適切）</option>
                  <option value="2">2 やや不満 (やや不適切)</option>
                  <option value="3">3 普通</option>
                  <option value="4">4 やや満足（やや適切）</option>
                  <option value="5">5 満足 (適切)</option>
                  <option value="0">不明</option>
                </b-select>
                <b-input
                  v-else
                  :value="supportOfficeAssessmentFilter(data.support.assessment1)"
                  :readonly="true"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-half">
              <b-field
                label="②ご利用者様は「当社」の対応に満足して頂けましたか？"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('assessment2')}"
                :message="errors.first('assessment2')"
              >
                <b-select
                  v-model="data.support.assessment2"
                  expanded
                  v-if="canSupportOfficeEdit"
                  name="assessment2"
                  data-vv-as="機器安全センター評価②"
                  v-validate="'selectRange:0:5'"
                >
                  <option value="1">1 不満 （不適切）</option>
                  <option value="2">2 やや不満 (やや不適切)</option>
                  <option value="3">3 普通</option>
                  <option value="4">4 やや満足（やや適切）</option>
                  <option value="5">5 満足 (適切)</option>
                  <option value="0">不明</option>
                </b-select>
                <b-input
                  v-else
                  :value="supportOfficeAssessmentFilter(data.support.assessment2)"
                  :readonly="true"
                ></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-full">
              <b-field
                label="備考"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('remarks')}"
                :message="errors.first('remarks')"
              >
                <b-input
                  type="textarea"
                  placeholder="機器安全センターの対応について、お気付きの点などございましたら記入お願いします。"
                  v-model="data.support.remarks"
                  :readonly="!canSupportOfficeEdit"
                  name="remarks"
                  data-vv-as="備考"
                  v-validate="'max:256'"
                  maxlength="256"
                ></b-input>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 戻るボタン -->
    <div style="text-align:center;">
      <b-button
        v-on:click="back"
        class="button"
        type="is-primary"
        icon-left="keyboard-backspace"
        native-type="button"
      >戻る</b-button>
      <b-button
        v-if="showAddButton"
        v-on:click="doRedist"
        class="button"
        type="is-primary"
        icon-left="content-save"
        native-type="button"
      >
        <span>登録する</span>
      </b-button>
      <b-button
        v-if="showSaveButton"
        v-on:click="doSave"
        class="button"
        type="is-primary"
        icon-left="content-save"
        native-type="button"
      >
        <span>一時保存する</span>
      </b-button>
      <b-button
        v-if="showResponseButton"
        v-on:click="doResponse"
        class="button"
        type="is-primary"
        icon-left="check"
        native-type="button"
      >
        <span>回答する</span>
      </b-button>
      <b-button
        v-if="showCompleteButton"
        v-on:click="doComplete"
        class="button"
        type="is-primary"
        icon-left="check"
        native-type="button"
      >
        <span>完了にする</span>
      </b-button>
      <b-button
        v-if="showWithdrawaleButton"
        v-on:click="doWithdrawale"
        class="button"
        type="is-primary"
        icon-left="select-off"
        native-type="button"
      >
        <span>取下げ</span>
      </b-button>
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
import StaffSearchTemplate from "./AppSelectStaff";
import SelectPatientTemplate from "./AppPatientSearch";

var officeMaster = [];
const StaffChangeModalForm = {
  props: ["officeCode"],
  components: {
    staffSearch: StaffSearchTemplate
  },
  methods: {
    save: function(event) {
      // 選択されている担当者を取得
      var staffInfo = this.$refs.staffList.getStaff();
      this.officeCode = staffInfo.officeCode;
      this.staffCode = staffInfo.id;
      this.staffName = staffInfo.lastName + staffInfo.firstName;
      this.setStaffs(this.officeCode, this.staffCode, this.staffName);
    },
    setStaffs: function(officeCode, staffCode, staffName) {
      // 選択された担当者情報を親画面に返却
      this.$emit("staff-change-event", officeCode, staffCode, staffName);
      this.$parent.close();
    }
  },
  data() {
    var office = this.$props.officeCode;
    return {
      office
    };
  },
  template: `
        <form action="">
          <div class="modal-card" style="width: 800px;">
            <header class="modal-card-head">
                <p class="modal-card-title" style="color: whitesmoke;">対応者選択</p>
            </header>
            <section class="modal-card-body">
              <staffSearch ref="staffList" v-bind:office-code="office" />
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="save">決定</button>
                <button class="button" type="button" @click="$parent.close()">閉じる</button>
            </footer>
          </div>
        </form>
      `
};

const SelectPatientForm = {
  components: {
    selectPatient: SelectPatientTemplate
  },
  methods: {
    select: function() {
      var item = this.$refs.selectedPatient.getSelectedItem();
      var flg = false;
      // 選択結果を画面に反映
      if (item) {
        var roleId = JSON.parse(sessionStorage.getItem("userInfo")).roleId;
        if (roleId != 1 && roleId != 2) {
          var selectOfficeCodes = item.officeCode.split(",");
          var officeCode = JSON.parse(sessionStorage.getItem("userInfo"))
            .officeCode;
          var officeCodes = JSON.parse(sessionStorage.getItem("userInfo"))
            .referenceOfficeCodes;
          for (var i = 0; i < selectOfficeCodes.length; i++) {
            if (selectOfficeCodes[i] == officeCode) {
              flg = true;
              break;
            }
            for (var j = 0; j < officeCodes.length; j++) {
              if (selectOfficeCodes[i] == officeCodes[j]) {
                flg = true;
                break;
              }
            }
          }
          if (flg) {
            this.$emit("set-patient", item);
            this.$parent.close();
          } else {
            this.showErrorMessage(
              "自身の所属する支店 もしくは 参照可能である支店<br>に紐付く情報を選択してください"
            );
          }
        } else {
          this.$emit("set-patient", item);
          this.$parent.close();
        }
      } else {
        this.showErrorMessage("患者情報を選択してください");
      }
    }
  },
  template: `
        <div>
          <selectPatient ref="selectedPatient" v-bind:select-mode="true" v-bind:is-nationwide-search="true"/>
          <div class="columns">
            <div class="column is-full" style="text-align:center;">
              <b-button
                v-on:click=$parent.close()
                class="button"
                type="is-primary"
                icon-left="keyboard-backspace"
                native-type="button"
                >戻る</b-button>
              <b-button                       
                v-on:click="select"
                class="button"
                type="is-primary"
                icon-left="content-save"
                native-type="button"
                >選択</b-button>
            </div>
          </div>
        </div>
      `
};
var newStatus = 0;
var status;
export default {
  name: "AppUrgentEdit",
  methods: {
    setPatientName: function(item) {
      this.data.inquiry.pacientCode = item.patientCode;
      this.data.inquiry.pacientName = item.patientName;
    },
    staffChanged: function(officeCode, staffCode, staffName) {
      // 選択された担当者情報をモーダル画面から取得
      // 画面に変更内容を反映
      this.data.support.officeCode = officeCode;
      this.data.support.staffCode = staffCode;
      this.data.support.staffName = staffName;
    },
    back: function(event) {
      this.$router.push({
        name: "AppUrgentList",
        params: { searchConditions: this.searchConditions }
      });
    },
    //登録
    doRedist: function(event) {
      this.$validator.validateAll().then(result => {
        if (result) {
          // パラメータ：newStatus = '1'
          //setUrgentInfo;
          newStatus = 1;
          var excuteApi = this.setUrgentInfoPOST;
          var successCallBack = this.setUrgentInfoSuccess;
          var errorCallBack = this.setUrgentInfoError;

          this.apiCall(excuteApi, successCallBack, errorCallBack);
        } else {
          scrollTo(0, 0);
        }
      });
    },
    doSave: function(event) {
      if (this.data.status == 0) {
        newStatus = 5;
      } else {
        newStatus = this.data.status;
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          var excuteApi = this.setUrgentInfoPOST;
          var successCallBack = this.setUrgentInfoSuccess;
          var errorCallBack = this.setUrgentInfoError;
          // WebAPI Call
          this.apiCall(excuteApi, successCallBack, errorCallBack);
        } else {
          scrollTo(0, 0);
        }
      });
    },
    doResponse: function(event) {
      this.$validator.validateAll().then(result => {
        if (result) {
          // パラメータ：newStatus = '2'
          newStatus = 2;
          var excuteApi = this.setUrgentInfoPOST;
          var successCallBack = this.setUrgentInfoSuccess;
          var errorCallBack = this.setUrgentInfoError;
          // WebAPI Call
          this.apiCall(excuteApi, successCallBack, errorCallBack);
        } else {
          scrollTo(0, 0);
        }
      });
    },
    doComplete: function(event) {
      this.$validator.validateAll().then(result => {
        if (result) {
          // パラメータ：newStatus = '3'
          newStatus = 3;
          var excuteApi = this.setUrgentInfoPOST;
          var successCallBack = this.setUrgentInfoSuccess;
          var errorCallBack = this.setUrgentInfoError;
          //  WebAPI Call
          this.apiCall(excuteApi, successCallBack, errorCallBack);
        } else {
          scrollTo(0, 0);
        }
      });
    },
    doWithdrawale: function(event) {
      this.$validator.validateAll().then(result => {
        if (result) {
          // パラメータ：newStatus = '4'
          newStatus = 4;
          var excuteApi = this.setUrgentInfoPOST;
          var successCallBack = this.setUrgentInfoSuccess;
          var errorCallBack = this.setUrgentInfoError;
          //  WebAPI Call
          this.apiCall(excuteApi, successCallBack, errorCallBack);
        } else {
          scrollTo(0, 0);
        }
      });
    },
    changeStaff: function(event) {
      this.isSupportStaffChangeActive = true;
    },
    changePatient: function(value) {
      this.isSelectPatientActive = true;
    },
    changeTime: function(time) {
      var hour = Math.floor(time * 0.01) * 60;
      var editMin = Math.floor(time * 0.01) * 100;
      var min = time - editMin;
      if (this.flg) {
        this.data.inquiry.startTime = hour + min;
      } else {
        this.data.inquiry.endTime = hour + min;
      }
    },
    //登録するApi
    setUrgentInfoPOST: function(client) {
      this.data.inquiry.alarmOccurrence = parseInt(
        this.data.inquiry.alarmOccurrence
      );
      this.data.inquiry.breathingCircuite = parseInt(
        this.data.inquiry.breathingCircuite
      );
      this.data.inquiry.deviceLocation = parseInt(
        this.data.inquiry.deviceLocation
      );
      this.data.inquiry.startTime = parseInt(
        this.data.inquiry.startTime.replace(/:/g, ""),
        10
      );
      this.data.inquiry.endTime = parseInt(
        this.data.inquiry.endTime.replace(/:/g, ""),
        10
      );
      if (this.data.inquiry.startTime) {
        this.flg = true;
        this.changeTime(this.data.inquiry.startTime);
      }
      if (this.data.inquiry.endTime) {
        this.flg = false;
        this.changeTime(this.data.inquiry.endTime);
      }

      this.data.inquiry.humidifier = parseInt(this.data.inquiry.humidifier);
      this.data.inquiry.kind = parseInt(this.data.inquiry.kind);
      this.data.inquiry.newDevice = parseInt(this.data.inquiry.newDevice);
      this.data.inquiry.physicalCondition = parseInt(
        this.data.inquiry.physicalCondition
      );
      this.data.inquiry.requestType = parseInt(this.data.inquiry.requestType);
      this.data.inquiry.usedDevice = parseInt(this.data.inquiry.usedDevice);
      this.data.inquiry.wearingStatus = parseInt(
        this.data.inquiry.wearingStatus
      );
      this.data.inquiry.supportType = String(this.data.inquiry.supportType);

      if (this.data.support.healthDamage)
        this.data.support.healthDamage = parseInt(
          this.data.support.healthDamage
        );
      if (this.data.support.newDevice)
        this.data.support.newDevice = parseInt(this.data.support.newDevice);
      if (this.data.support.replacement)
        this.data.support.replacement = parseInt(this.data.support.replacement);
      if (this.data.support.location)
        this.data.support.location = parseInt(this.data.support.location);
      if (this.data.support.assessment1)
        this.data.support.assessment1 = parseInt(this.data.support.assessment1);
      if (this.data.support.assessment2)
        this.data.support.assessment2 = parseInt(this.data.support.assessment2);
      if (this.data.support.dealType)
        this.data.support.dealType = parseInt(this.data.support.dealType);

      var body = this.data;
      body.status = newStatus;
      var obj = JSON.parse(JSON.stringify(body));

      return client.apis.apiUrgentInfo.setUrgentInfoPOST({
        body: obj
      });
    },
    setUrgentInfoSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.showSuccess(result);
      // 登録に成功した場合、ページ遷移
      this.$router.push({
        name: "AppUrgentList",
        params: { searchConditions: this.searchConditions }
      });
    },
    setUrgentInfoError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getUrgentInfoPOST: function(client) {
      return client.apis.apiUrgentInfo.getUrgentInfoPOST({
        body: { code: String(this.code) }
      });
    },
    getUrgentInfoSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
      this.officeCode = this.data.inquiry.responsibleOfficeCode;
      if (typeof this.data.inquiry.staffCode == "string") {
        this.data.inquiry.staffCode = parseInt(this.data.inquiry.staffCode);
      }
      if (typeof this.data.support.staffCode == "string") {
        this.data.support.staffCode = parseInt(this.data.support.staffCode);
      }
      this.status = this.data.status;
      this.data.support.officeCode = this.data.inquiry.responsibleOfficeCode;

      // 文字列⇒Date型変換処理(日にち)
      if (this.data.inquiry.date) {
        this.date = this.parseDate(this.data.inquiry.date);
      }
      if (this.data.support.date) {
        this.supportDate = this.parseDate(this.data.support.date);
      }
      if (this.data.inquiry.startTime) {
        this.startTime = this.parseTime(this.data.inquiry.startTime);
      }
      if (this.data.inquiry.endTime) {
        this.endTime = this.parseTime(this.data.inquiry.endTime);
      }

      //登録したユーザ支店と現在のユーザ支店
      //対応したユーザ支店と現在のユーザ支店
      if (
        this.data.inquiry.officeCode === this.userInfo.officeCode &&
        this.data.support.officeCode === this.userInfo.officeCode
      ) {
      } else {
        if (this.data.inquiry.officeCode === this.userInfo.officeCode) {
          //支店対応の項目は編集不可
          this.canSupportOfficeEdit = false;
        }
        //受電対応の項目は編集不可
        if (this.data.support.officeCode === this.userInfo.officeCode) {
          this.canInquiryEdit = false;
        }
      }
      if (
        this.data.inquiry.officeCode != this.userInfo.officeCode &&
        this.data.support.officeCode != this.userInfo.officeCode
      ) {
        this.canSupportOfficeEdit = false;
        this.canInquiryEdit = false;
      }

      //登録したユーザ
      if (this.data.inquiry.officeCode === this.userInfo.officeCode)
        this.canOnButton = true;

      if (this.data.status === 1) {
        if (this.canInquiryEdit || this.canSupportOfficeEdit)
          this.showSaveButton = true;
        if (this.canSupportOfficeEdit) this.showResponseButton = true;
      } else if (this.data.status === 2) {
        if (this.canInquiryEdit || this.canSupportOfficeEdit)
          this.showSaveButton = true;
        if (this.canOnButton) {
          this.showCompleteButton = true;
          this.showWithdrawaleButton = true;
        }
      } else if (this.data.status === 3 || this.data.status === 4) {
        this.canSupportOfficeEdit = false;
        this.canInquiryEdit = false;
      } else if (this.data.status === 5) {
        this.showAddButton = true;
      } else {
        this.canSupportOfficeEdit = false;
        this.canInquiryEdit = false;
      }
    },
    getUrgentInfoError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getPatientInfoPOST: function(client) {
      this.patientCode;
      return client.apis.apiPatient.getPatientInfoPOST({
        body: { code: this.patientCode }
      });
    },
    getPatientInfoSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      ///登録するボタン
      this.showAddButton = true;
      this.data.inquiry.pacientName = result.obj.name;
      this.data.inquiry.pacientCode = result.obj.code;
    },
    getPatientInfoError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    }
  },
  computed: {
    inquiryKindFilter: function() {
      return function(value) {
        if (value === 0) {
          return "呼吸";
        } else if (value === 1) {
          return "睡眠";
        } else if (value === 2) {
          return "当番変更";
        } else if (value === 3) {
          return "呼吸ケア用品";
        } else if (value === 4) {
          return "間違い";
        } else if (value === 5) {
          return "ワンギリ";
        } else if (value === 6) {
          return "その他";
        }
      };
    },
    inquirySupportTypeFilter: function() {
      return function(value) {
        if (value === 0) {
          return "1：電話番号案内";
        } else if (value === 1) {
          return "2：入電で一時解決";
        } else if (value === 2) {
          return "3：待機当番へ対応依頼（支店担当含む）";
        } else if (value === 3) {
          return "4：その他（1～3以外）";
        }
      };
    },
    inquiryDevLocationFilter: function() {
      return function(value) {
        if (value === 0) {
          return "院内";
        } else if (value === 1) {
          return "在宅";
        } else if (value === 2) {
          return "施設";
        } else if (value === 3) {
          return "業者";
        } else if (value === 4) {
          return "その他";
        }
      };
    },
    inquiryWearingStatusFilter: function() {
      return function(value) {
        if (value === 0) {
          return "挿管";
        } else if (value === 1) {
          return "気管切開";
        } else if (value === 2) {
          return "鼻ｶﾆｭｰﾗ";
        } else if (value === 3) {
          return "ﾏｽｸ";
        } else if (value === 4) {
          return "鼻ﾏｽｸ";
        } else if (value === 5) {
          return "鼻口ﾏｽｸ";
        } else if (value === 6) {
          return "ﾄｰﾀﾙﾌｪｲｽﾏｽｸ";
        } else if (value === 7) {
          return "N/A";
        } else if (value === 8) {
          return "不明";
        }
      };
    },
    inquiryHumidifierFilter: function() {
      return function(value) {
        if (value === 0) {
          return "加湿器";
        } else if (value === 1) {
          return "人工鼻";
        } else if (value === 2) {
          return "N/A";
        } else if (value === 3) {
          return "不明";
        }
      };
    },
    situationFilter: function() {
      return function(value) {
        if (value === 0) {
          return "いいえ";
        } else if (value === 1) {
          return "はい";
        } else if (value === 2) {
          return "N/A";
        } else if (value === 3) {
          return "不明";
        }
      };
    },
    inquiryRequestTypeFilter: function() {
      return function(value) {
        if (value === 0) {
          return "問合せ";
        } else if (value === 1) {
          return "連絡";
        } else if (value === 2) {
          return "用品注文";
        } else if (value === 3) {
          return "レンタル依頼";
        } else if (value === 4) {
          return "引上げ依頼";
        } else if (value === 5) {
          return "不具合（電源・バッテリー）";
        } else if (value === 6) {
          return "不具合（回路等が原因と思われる）";
        } else if (value === 7) {
          return "設定・使用方法の問題と思われる";
        } else if (value === 8) {
          return "不具合（器械原因と思われる）";
        } else if (value === 9) {
          return "作動停止";
        } else if (value === 10) {
          return "詳細不明";
        } else if (value === 11) {
          return "除外";
        }
      };
    },
    inquiryBreathingCircuiteFilter: function() {
      return function(value) {
        if (value === 0) {
          return "リューザブル";
        } else if (value === 1) {
          return "ディスポ";
        } else if (value === 2) {
          return "ﾊﾟｯｼﾌﾞ";
        } else if (value === 3) {
          return "ｱｸﾃｨﾌﾞ";
        } else if (value === 4) {
          return "ｱｸﾃｨﾌﾞﾌﾛｰ";
        } else if (value === 5) {
          return "N/A";
        } else if (value === 6) {
          return "不明";
        }
      };
    },
    inquiryResponsibleOfficeFilter: function() {
      return function(value) {
        var officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
        var officeElement = officeMaster.find(v => v.officeCode === value);
        if (officeElement) {
          return officeElement.officeName;
        }
        return "";
      };
    },
    supportOfficeReplacementFilter: function() {
      return function(value) {
        if (value === 0) {
          return "あり";
        } else if (value === 1) {
          return "なし";
        }
      };
    },
    supportOfficeLocationFilter: function() {
      return function(value) {
        if (value === 0) {
          return "現場";
        } else if (value === 1) {
          return "支店";
        } else if (value === 2) {
          return "確認不可";
        }
      };
    },
    supportOfficedealTypeFilter: function() {
      return function(value) {
        if (value === 0) {
          return "電話/商品発送にて対応";
        } else if (value === 1) {
          return "営業時間内出動にて対応";
        } else if (value === 2) {
          return "営業時間外出動にて対応";
        }
      };
    },
    supportOfficeAssessmentFilter: function() {
      return function(value) {
        if (value === 0) {
          return "不明";
        } else if (value === 1) {
          return "1 不満 （不適切）";
        } else if (value === 2) {
          return "2 やや不満 (やや不適切)";
        } else if (value === 3) {
          return "3 普通";
        } else if (value === 4) {
          return "4 やや満足（やや適切）";
        } else if (value === 5) {
          return "5 満足  (適切)";
        }
      };
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    //AppUrgentListResultからデータの受け取り
    var patientCode = this.$route.params["patientCode"];
    var code = this.$route.params["code"];
    var flg;
    var searchConditions = this.$route.params["searchConditions"];

    //項目編集
    //受電対応部;
    var canInquiryEdit = true;
    ///支店対応部
    var canSupportOfficeEdit = true;
    //ボタン出力
    var canOnButton = false;
    var showAddButton = false;
    var showSaveButton = false;
    var showResponseButton = false;
    var showCompleteButton = false;
    var showWithdrawaleButton = false;

    // 新規作成のため、初期値 空文字を設定
    //登録するボタン
    var data = {
      status: 0,
      completedDate: "",
      inquiry: {
        staffCode: userInfo.id,
        staffName: userInfo.fullName,
        officeCode: userInfo.officeCode,
        date: "",
        startTime: 0,
        endTime: 0,
        kind: null,
        senderName: "",
        incomingPhoneNumber: "",
        contactPhoneNumber: "",
        pacientCode: "",
        pacientName: "",
        hospitalName: "",
        hospitalWard: "",
        hospitalSection: "",
        deviceLocation: null,
        requestType: null,
        responsibleOfficeCode: "",
        deviceName: "",
        combinedDeviceName: "",
        breathingCircuite: null,
        wearingStatus: null,
        humidifier: null,
        alarmOccurrence: null,
        usedDevice: null,
        physicalCondition: null,
        newDevice: null,
        inquiryContent: "",
        supportType: "",
        supportContent: ""
      },
      support: {
        kind: {}
      }
    };

    if (patientCode) {
      var excuteApi = this.getPatientInfoPOST;
      var successCallBack = this.getPatientInfoSuccess;
      var errorCallBack = this.getPatientInfoError;
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    }
    if (!code) {
      showAddButton = true;
      showSaveButton = true;
    } else {
      var excuteApi = this.getUrgentInfoPOST;
      var successCallBack = this.getUrgentInfoSuccess;
      var errorCallBack = this.getUrgentInfoError;
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    }

    status = data.status;
    officeMaster = JSON.parse(sessionStorage.getItem("referenceEnableOffice"));
    var officeCode = "";
    return {
      data,
      flg: "",
      date: "",
      startTime: "",
      endTime: "",
      canInquiryEdit,
      canSupportOfficeEdit,
      showAddButton,
      showSaveButton,
      showResponseButton,
      showCompleteButton,
      showWithdrawaleButton,
      officeMaster,
      status,
      supportDate: "",
      code,
      patientCode,
      isSupportStaffChangeActive: false,
      isSelectPatientActive: false,
      searchConditions,
      userInfo,
      officeCode
    };
  },
  filters: {},
  components: {
    "staffChange-modal": StaffChangeModalForm,
    "selectPatient-form": SelectPatientForm
  },
  watch: {
    date(value) {
      this.data.inquiry.date = this.formatDate(value);
    },
    startTime(value) {
      var start = this.formatTime(value);
      this.data.inquiry.startTime = start;
    },
    endTime(value) {
      var end = this.formatTime(value);
      this.data.inquiry.endTime = end;
    },
    supportDate(value) {
      this.data.support.date = this.formatDate(value);
    }
  },
  created: function() {
    this.$validator.extend("supportKind", {
      getMessage: field => `対応区分を選択してください。`,
      validate: () => {
        var kind = this.data.support.kind;
        var ret =
          kind.operationStop ||
          kind.malfunction ||
          kind.malfunctionPower ||
          kind.defective ||
          kind.configuration ||
          kind.other;
        return ret;
      }
    });
    this.$validator.extend("endTimeCheck", {
      getMessage: field => `開始時間以降の時間を選択してください。`,
      validate: endTime => {
        var ret = true;
        var startTime = this.startTime;
        if (startTime) {
          if (startTime > endTime) {
            ret = false;
          }
        }
        return ret;
      }
    });
  }
};
</script>
<style>
.tableTitle {
  background-color: #000894;
  text-align: center;
  vertical-align: middle;
}
.tableTitle > div {
  text-align: center;
  vertical-align: middle;
  color: whitesmoke;
}
.subTitle {
  text-align: left;
  vertical-align: middle;
  font-weight: 700;
}
.field.is-floating-label .label {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/AppUrgentEdit.vue